import React from 'react'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import BaseFont, {
  FontUpdate,
} from 'client/components/core/Sidebar/components/Settings/components/Font/BaseFont'

export const FontSelectorControl = ({
  update,
  labelText,
  hideLabel,
  globalFontFamily,
  inheritedFontTypeLabel,
  isRootSetting,

  fontFamily,
  mobileFontFamily,
  fontWeight,
  mobileFontWeight,
  fontStyle,
  mobileFontStyle,
}: {
  update: (updatedFont: FontUpdate) => void
  labelText?: string
  hideLabel?: boolean
  globalFontFamily: string | undefined
  inheritedFontTypeLabel?: string
  isRootSetting?: boolean

  fontFamily: string | undefined
  mobileFontFamily: string | undefined
  fontWeight: string | undefined
  mobileFontWeight: string | undefined
  fontStyle: string | undefined
  mobileFontStyle: string | undefined
}) => {
  const { isMobile } = useDeviceModeContext()

  const resultFontFamily = isMobile
    ? mobileFontFamily || fontFamily
    : fontFamily
  const resultFontWeight = isMobile
    ? mobileFontWeight || fontWeight
    : fontWeight
  const resultFontStyle = isMobile ? mobileFontStyle || fontStyle : fontStyle

  return (
    <BaseFont
      labelText={labelText}
      fontFamily={resultFontFamily}
      fontStyle={resultFontStyle}
      fontWeight={resultFontWeight}
      update={update}
      globalFontFamily={globalFontFamily}
      inheritedFontTypeLabel={inheritedFontTypeLabel}
      hideLabel={hideLabel}
      isRootSetting={isRootSetting}
    />
  )
}
